import ReactInputMask from "react-input-mask";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  width: 100%;
`;

export const Label = styled.label`
  width: 100%;
  margin: 0 0 1rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
`;

export const Required = styled.span`
  font-family: Inter;
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.red};
`;

interface IInputContainer {
  hasLabel: boolean;
}

export const InputContainer = styled.div<IInputContainer>`
  display: flex;
  align-items: center;

  width: 100%;
  height: fit-content;

  margin: ${(props) => (props.hasLabel ? "0" : "2.5rem 0 0")};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: fit-content;
  width: fit-content;

  position: absolute;
  right: 1rem;

  .ant-spin.ant-spin-spinning {
    display: flex;
    align-items: center;
  }
`;

export interface IInputProps {
  error: boolean;
}

export const Input = styled(ReactInputMask)<IInputProps>`
  width: 100%;
  height: 3rem;
  padding: 0 1rem;

  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;

  border-radius: 0.5rem;
  border: 0.094rem solid
    ${(props) =>
      props.error
        ? props.theme?.checkoutStepsOffers?.red
        : props.theme?.checkoutStepsOffers?.inputBorderColor};
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
  background: ${({ theme }) => theme.checkoutStepsOffers?.inputBackground};

  position: relative;

  &::placeholder {
    color: ${({ theme }) => theme.checkoutStepsOffers?.placeholderColor};
  }

  &:disabled {
    opacity: 0.8;
  }

  &:hover {
    border: 0.094rem solid
      ${(props) =>
        `${
          props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
          props.theme?.colors?.primary
        }a0`};
  }

  &:focus {
    border: 0.094rem solid
      ${(props) =>
        `${
          props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
          props.theme?.colors?.primary
        }a8`};
  }
`;

export const InvalidMessage = styled.span`
  width: 100%;
  margin: 0.5rem 0 0;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.red};
`;
